interface LoadingSpinnerProps {
  readonly size?: 'sm' | 'md' | 'lg';
}

const SIZE_MAP = {
  sm: { height: '1rem', width: '1rem', borderWidth: '2px' },
  md: { height: '2rem', width: '2rem', borderWidth: '3px' },
  lg: { height: '3rem', width: '3rem', borderWidth: '3px' },
} as const;

export const LoadingSpinner = ({ size = 'md' }: LoadingSpinnerProps) => {
  const dims = SIZE_MAP[size];

  return (
    <div className="flex items-center justify-center">
      <div
        className="animate-spin"
        style={{
          ...dims,
          borderStyle: 'solid',
          borderColor: 'var(--color-primary-600)',
          borderTopColor: 'transparent',
          borderRadius: 'var(--radius-full)',
        }}
      />
    </div>
  );
};
